/**
 * Query to fetch a single marketplace_org with all details
 */
const orgDetailsQuery = `
query MarketplaceOrgDetails($id: ID!) {
  marketplace_org(id: $id) {
    objectId
    name
    vat_code
    city
    country
    country_code
    province
    street
    is_active
    marketplace_seller_pointer {
      objectId
      name
    }
    org_pointer {
      objectId
      nome
      email
      tipo_istanza
      stato
    }
    createdAt
    updatedAt
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default orgDetailsQuery;
